import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import CheckImg from "../../../../../../Assets/Images/aaa.png";
import { isSpaceInString } from "Utils";


const getSelectedSubCategory = (subcategories, flag) => {
  let subcategories1 = subcategories;
  subcategories1 = subcategories1.map((subcategory) => ({
    ...subcategory,
    expensepolicysubcategoryid: 0,
    isselected: flag,
    subcategoryname: subcategory.subcategoryname,
    subexpensesubcategoryid: subcategory.subexpensesubcategoryid,
  }));
  return subcategories1 || [];
};
class define extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      selectedPolicy: props.selectedPolicy,
      addall: false,
      DefaultExpenseCategories: props.selectedPolicy.category || [],
    };

    this.selectAll = this.selectAll.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.props.onRef({
      onNext: this.onSubmit,
    });

    const { selectedPolicy } = this.props;
    let { copypolicy } = this.props;
    copypolicy = JSON.parse(copypolicy);
    console.log("copypolicy: ", copypolicy);
    const allcat = [];
    copypolicy.category
      && copypolicy.category.forEach((category) => {
        const findcat = selectedPolicy
          && selectedPolicy.category
          && selectedPolicy.category.find(
            (cat) => category.subexpensecategoryid == cat.subexpensecategoryid,
          );
        const catindex = selectedPolicy
          && selectedPolicy.category
          && selectedPolicy.category.findIndex(
            (cat) => category.subexpensecategoryid == cat.subexpensecategoryid,
          );
        if (findcat) {
          const subcats = [];
          category.subcategory
            && category.subcategory.forEach((subcat) => {
              const findsubcat = selectedPolicy
                && selectedPolicy.category
                && selectedPolicy.category[catindex].subcategory
                && selectedPolicy.category[catindex].subcategory.find(
                  (subcat1) =>
                    subcat.subexpensesubcategoryid
                    == subcat1.subexpensesubcategoryid,
                );
              if (findsubcat) {
                subcats.push(findsubcat);
              } else {
                subcats.push(subcat);
              }
            });

          findcat.subcategory = subcats;
          allcat.push(findcat);
        } else {
          allcat.push(category);
        }
      });

    selectedPolicy.category = allcat || [];

    if (allcat.find((cat) => !cat.isselected)) {
      this.setState({
        addall: false,
      });
    } else {
      this.setState({
        addall: true,
      });
    }

    this.setState({
      selectedPolicy,
      DefaultExpenseCategories: allcat,
    });
  }

  handleChange(name, e) {
    const { selectedPolicy } = this.state;
    selectedPolicy[name] = e;
    this.setState({
      selectedPolicy,
    });
  }

  selectAll(flag) {
    let DefaultExpenseCategories = [...this.state.DefaultExpenseCategories];
    DefaultExpenseCategories = DefaultExpenseCategories.map((category) => ({
      ...category,
      isselected: flag,
      subcategory: getSelectedSubCategory(category.subcategory, flag),
    }));
    this.setState({
      // selectedPolicy: { ...this.state.selectedPolicy, category: DefaultExpenseCategories },
      DefaultExpenseCategories,
      addall: flag,
    });
  }

  selectAllCategory(subexpensecategoryid, flag) {
    const DefaultExpenseCategories = [...this.state.DefaultExpenseCategories];
    const categoryIndex = DefaultExpenseCategories.findIndex(
      (category) => category.subexpensecategoryid == subexpensecategoryid,
    );
    const categoryObj = DefaultExpenseCategories.find(
      (category) => category.subexpensecategoryid == subexpensecategoryid,
    );
    if (categoryObj) {
      categoryObj.subcategory = (categoryObj.subcategory
          && categoryObj.subcategory.map((subcategory) => ({
            ...subcategory,
            isselected: flag,
          })))
        || [];
      categoryObj.isselected = flag;
      if (categoryIndex != -1) {
        DefaultExpenseCategories[categoryIndex] = categoryObj;
      }
    }
    if (DefaultExpenseCategories.find((category) => !category.isselected)) {
      this.setState({
        addall: false,
      });
    } else {
      this.setState({
        addall: true,
      });
    }

    if (DefaultExpenseCategories.length < 2) {
      this.setState({
        addall: flag,
      });
    }
    this.setState({
      DefaultExpenseCategories,
    });
  }

  selecteSubCategory(categoryid, subcategoryid, flag) {
    const DefaultExpenseCategories = [...this.state.DefaultExpenseCategories];
    const categoryIndex = DefaultExpenseCategories.findIndex(
      (category) => category.subexpensecategoryid == categoryid,
    );
    const categoryObj = DefaultExpenseCategories.find(
      (category) => category.subexpensecategoryid == categoryid,
    );
    if (categoryObj && categoryObj.subcategory) {
      const subcategoryIndex = categoryObj.subcategory.findIndex(
        (subcategory) => subcategory.subexpensesubcategoryid == subcategoryid,
      );
      const subcategoryObj = categoryObj.subcategory.find(
        (subcategory) => subcategory.subexpensesubcategoryid == subcategoryid,
      );
      subcategoryObj.isselected = flag;
      if (subcategoryIndex != -1) {
        categoryObj.subcategory[subcategoryIndex] = subcategoryObj;
      }

      const check = categoryObj.subcategory.filter(
          (subcategory) => !subcategory.isselected,
        ) || [];
      if (check.length > 0) {
        categoryObj.isselected = false;
      } else {
        categoryObj.isselected = true;
      }
      DefaultExpenseCategories[categoryIndex] = categoryObj;
    }

    const checkaddall = DefaultExpenseCategories.filter((cat) => !cat.isselected) || [];
    if (checkaddall.length > 0) {
      this.setState({
        addall: false,
      });
    } else {
      this.setState({
        addall: true,
      });
    }
    this.setState({
      DefaultExpenseCategories,
    });
  }

  onSubmit = () => {
    const { selectedPolicy, DefaultExpenseCategories } = this.state;
    let flag = false;
    selectedPolicy.category = DefaultExpenseCategories;
    selectedPolicy.category
      && selectedPolicy.category.forEach((category) => {
        category.subcategory
          && category.subcategory.forEach((subcategory) => {
            if (subcategory.isselected) {
              flag = true;
              return;
            }
          });
        if (flag) {
          return;
        }
      });

    const savecategory = [];
    selectedPolicy.category.forEach((category) => {
      const subs = category.subcategory.filter((subcategory) => subcategory.isselected)
        || [];
      if (subs.length > 0) {
        savecategory.push({
          ...category,
          subcategory: [...subs],
        });
      }
    });

    selectedPolicy.category = savecategory;
    console.log("selectedPolicy: ", selectedPolicy);
    if (selectedPolicy.policyname && !isSpaceInString(selectedPolicy.policyname)) {
      selectedPolicy.policyname = selectedPolicy.policyname.trim();
    }
     if (!selectedPolicy.policyname) {
      this.props.enqueueSnackbar("Please enter policy name", {
        variant: "error",
      });
    } else if (!flag) {
      this.props.enqueueSnackbar(
        "Please select at least one type of category",
        { variant: "error" },
      );
    } else {
      console.log("selectedPolicy11: ", selectedPolicy);
      this.props.onNextClick(selectedPolicy);
    }
  };

  render() {
    const { selectedPolicy } = this.state;
    return (
      <div className="stepper-data">
        <Grid container>
          <Grid item xs={12} md={12} sm={12}>
            <div className="form-group">
              <p className="input-label">
                <FormattedMessage
                  id="#"
                  defaultMessage="Lets give this policy a name"
                />
              </p>
              <TextField
                id="outlined-dense"
                margin="dense"
                variant="outlined"
                value={selectedPolicy.policyname}
                onChange={(e) =>
                  this.handleChange("policyname", e.target.value)
                }
              />
            </div>
            <div className="form-group">
              <p className="input-label">
                <FormattedMessage id="#" defaultMessage="Description" />
              </p>
              <TextField
                id="outlined-dense"
                margin="dense"
                variant="outlined"
                onChange={(e) =>
                  this.handleChange("description", e.target.value)
                }
                value={selectedPolicy.description}
              />
            </div>
            <div>
              <p className="input-label">
                Select the categories and types to be assigned
              </p>
              <div className="assigned-expense-category">
                <div
                  className="margin-top-16 cursurpointer"
                  style={{ padding: "0px 24px" }}
                >
                  <span className="all-select">Add all</span>
                  {this.state.addall ? (
                    <span
                      className="floatright"
                      style={{ height: 16 }}
                      onClick={() => this.selectAll(false)}
                    >
                      <img src={CheckImg} alt="" height="18" />
                    </span>
                  ) : (
                    <span
                      className="not-selected"
                      onClick={() => this.selectAll(true)}
                    ></span>
                  )}
                </div>
                <div
                  style={{
                    background: "#d9dadb",
                    height: 1,
                    width: "100%",
                    position: "relative",
                    top: 11,
                  }}
                ></div>
                <div className="expenses-list">
                  <div className="expense-category-data">
                    {this.state.DefaultExpenseCategories.map((category) => (
                      <div key={"cat"} style={{ paddingTop: 10 }}>
                        <div
                          style={{
                            background: "#d9dadb",
                            height: 1,
                            width: "90%",
                            position: "relative",
                            top: 11,
                          }}
                        ></div>
                        <div style={{ padding: "0px 0px 10px 14px" }}>
                          <span
                            className="policy-expense-category-name"
                            style={{ fontSize: 14 }}
                          >
                            {category.categoryname}
                          </span>
                          {category.isselected ? (
                            <span
                              className="floatright cursurpointer"
                              style={{ height: 16 }}
                              onClick={() =>
                                this.selectAllCategory(
                                  category.subexpensecategoryid,
                                  false,
                                )
                              }
                            >
                              <img src={CheckImg} alt="" height="18" />
                            </span>
                          ) : (
                            <span
                              className="not-selected cursurpointer"
                              onClick={() =>
                                this.selectAllCategory(
                                  category.subexpensecategoryid,
                                  true,
                                )
                              }
                            ></span>
                          )}
                          {category.subcategory
                            && category.subcategory.map((subcategory) => (
                              <div key="subcat" className="expense-subcategory">
                                <span style={{ float: "left", fontSize: 14 }}>
                                  {subcategory.subcategoryname}
                                </span>
                                {subcategory.isselected ? (
                                  <span
                                    className="floatright cursurpointer"
                                    style={{ height: 16 }}
                                    onClick={() =>
                                      this.selecteSubCategory(
                                        category.subexpensecategoryid,
                                        subcategory.subexpensesubcategoryid,
                                        false,
                                      )
                                    }
                                  >
                                    <img src={CheckImg} alt="" height="18" />
                                  </span>
                                ) : (
                                  <span
                                    className="not-selected cursurpointer"
                                    onClick={() =>
                                      this.selecteSubCategory(
                                        category.subexpensecategoryid,
                                        subcategory.subexpensesubcategoryid,
                                        true,
                                      )
                                    }
                                  ></span>
                                )}
                              </div>
                            ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}
export default withSnackbar(define);
